import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieSaldoDeudoresPorEmpresa from '../PieSaldoDeudoresPorEmpresa/PieSaldoDeudoresPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

import * as actions from '../../../../store/actions/index';

const MultiChartSaldoDeudorPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieSaldoDeudoresPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Saldo deudores por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalSaldos)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.saldosPorEmpresa}
                onChangeViewClick={handleChangeView}
                title={`Saldo deudores por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalSaldos)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
      saldosPorEmpresa: state.multiempresa.saldoDeudoresPorEmpresa.saldos,
      totalSaldos: state.multiempresa.saldoDeudoresPorEmpresa.totalSaldos,
      loading: state.multiempresa.saldoDeudoresPorEmpresa.loading,
      estaCargado: state.multiempresa.saldoDeudoresPorEmpresa.estaCargado,
      estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.saldoDeudoresMultiempresa
    };
  };
  
  
const mapDispatchToProps = (dispatch) => {
    return {
        onLoadChart: () => dispatch(actions.loadSaldoDeudoresPorEmpresa())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartSaldoDeudorPorEmpresa);